/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ProjectsControllerBulkUpdateMutationRequest, ProjectsControllerBulkUpdateMutationResponse, ProjectsControllerBulkUpdate400, ProjectsControllerBulkUpdate401 } from "../../models/projectsController/ProjectsControllerBulkUpdate";

function getProjectsControllerBulkUpdateUrl() {
  const res = { method: 'PATCH', url: `/api/v1/projects/bulk` as const }  
  return res
}

/**
 * @description Update multiple projects in one call. Each item carries its own attributes. Moving (parentScopeId) and archiving are not accepted here. All projects must belong to one organization. Returns 200 if all items succeed, 207 Multi-Status if any fail, 400 for request-level validation errors.
 * @summary Bulk update projects
 * {@link /api/v1/projects/bulk}
 */
export async function projectsControllerBulkUpdate(data: ProjectsControllerBulkUpdateMutationRequest, config: Partial<RequestConfig<ProjectsControllerBulkUpdateMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<ProjectsControllerBulkUpdateMutationResponse, ResponseErrorConfig<ProjectsControllerBulkUpdate400 | ProjectsControllerBulkUpdate401>, ProjectsControllerBulkUpdateMutationRequest>({ method : "PATCH", url : getProjectsControllerBulkUpdateUrl().url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}